import { jwtDecode } from 'jwt-decode';

export const getTokenData = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Помилка декодування токену:', error);
    return null;
  }
};

export const setToken = (token) => {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const isTokenExpired = () => {
  const tokenData = getTokenData();
  if (!tokenData) return true;
  
  const currentTime = Date.now() / 1000;
  return tokenData.exp < currentTime;
}; 